export default __webpack_public_path__ + "static/media/background.cb9c6f3a.svg";